let gridList = document.querySelector('.grid');

if (gridList?.querySelector('.wishlist-block')) {
    let wishlistBlocks = document.querySelectorAll('.wishlist-block.d-none');
    let wishlistBlockTotal = gridList.dataset.totalBlocks;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && !mutation.target.hasAttribute(mutation.attributeName)) {
                let referenceBlock = gridList.querySelector('.product-item');
                let index = 0
                wishlistBlocks.forEach((block) => {
                    if (block.dataset.placement) {
                        const existingItem = gridList.children[parseInt(block.dataset.placement) + parseInt(wishlistBlockTotal) - 1];
                        gridList.insertBefore(block, existingItem);
                    }
                    wishlistBlockTotal -= 1;
                    block.classList.remove('d-none');

                    block.style.gridColumn = 'span 2';

                    let H = referenceBlock.clientHeight;
                    let W = referenceBlock.clientWidth;

                    let a = (2 * W - 20) / (H / 2);

                    block.querySelector('.image-wrapper').style.setProperty('--aspect-ratio', a);
                    block.querySelector('.image-wrapper').style.setProperty('--aspect-ratio-mobile', a);
                })
            }
        });
    });

    const config = { attributes: true, attributeOldValue: true, subtree: false };

    observer.observe(gridList, config);
}
